import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/tr';

import trTranslation from './translations/tr/translation.json';
import trCommon from './translations/tr/common.json';
import enTranslation from './translations/en/translation.json';
import enCommon from './translations/en/common.json';

export const defaultNS = 'translation';
export const resources = {
  tr: {
    translation: trTranslation,
    common: trCommon,
  },
  en: {
    translation: enTranslation,
    common: enCommon,
  },
};

i18next
  .use(LanguageDetector) // TODO: https://github.com/i18next/i18next-browser-languageDetector
  .use(initReactI18next)
  .init(
    {
      debug: process.env.NODE_ENV !== 'production',
      // returnNull: false,
      fallbackLng: ['tr', 'en'],
      supportedLngs: ['tr', 'en'],
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      ns: ['translation', 'common'],
      resources,
      defaultNS,
    },
    () => {
      dayjs.locale(i18next.language);
      document.documentElement.lang = i18next.language; // <html lang=''>
    }
  );

export default i18next;
